import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { LinkSubprojectToProjectModel } from "@/store/models/project/linkSubprojectToProject";
import { NotificationsModule } from "@/store/modules/notification.module";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import requestTrackingMachine from "../machines/requestTrackingMachine";
import { interpret } from "xstate/lib/interpreter";
import { ProjectModule } from "@/store/modules/project.module";
import DeleteComponent from "@/components/deleteComponent.vue";
import { bus } from "@/main";
import Layout from "@/router/layouts/main.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let RequestTrackingComponent = /** @class */ (() => {
    var _a;
    let RequestTrackingComponent = class RequestTrackingComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.tenantId = localStorage.getItem("tenantId");
            this.parentProjectId = "";
            this.linkProject = new LinkSubprojectToProjectModel();
            this.machine = requestTrackingMachine.withContext({});
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        //Methods
        linkSubProjectWithParentProject() {
            this.validate("linkSubProjectToParentProject").then((response) => {
                if (response) {
                    this.linkProject.projectId = this.parentProjectId;
                    this.linkProject.subProjectId = this.notificationDetails.subProjectId;
                    this.linkProject.employeeId = this.notificationDetails.requestedBy;
                    this.linkProject.notificationId = this.notification.id;
                    this.machineService.send({ type: "LINKING_SUBPROJECT_WITH_PARENTPROJECT", payLoad: this.linkProject });
                    this.$emit("update:isAccept");
                }
            });
        }
        showLinkProjectModal(requestProject) {
            if (!requestProject.isComplete) {
                return;
            }
            NotificationsModule.UpdateIsSeen(requestProject.id).then((response) => { });
            this.machineService.send({ type: "LINK_SUBPROJECT_WITH_PARENTPROJECT", projectId: requestProject.notificationData.subProjectId });
        }
        cancelModal() {
            this.requestTrackingNotificationId = "";
            this.$emit("update:isAccept");
            this.parentProjectId = "";
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        showRejectModal(notificationId) {
            if (!this.notification.isComplete) {
                return;
            }
            this.notificationId = notificationId;
            this.machineService.send({ type: "REJECT_SUBPROJECT_LINKING" });
        }
        rejectNotification() {
            this.machineService.send({ type: "REJECTING_SUBPROJECT_LINKING", notificationId: this.notificationId });
        }
        emitRejectedNotification() {
            this.$emit("notificationClicked", this.notification);
        }
        UpdateIsSeen(notificationId) {
            this.machineService.send({ type: "MARK_AS_READ", notificationId: notificationId });
        }
        ShowAcceptLinkModal() {
            this.parentProjectId = "";
            if (this.isAccept) {
                this.machineService.send({ type: "LINK_SUBPROJECT_WITH_PARENTPROJECT", projectId: this.notificationDetails.subProjectId });
            }
            else {
                this.notificationId = this.notification.id;
                this.machineService.send({ type: "REJECT_SUBPROJECT_LINKING" });
                this.emitRejectedNotification();
            }
        }
        get parentProjects() {
            return ProjectModule.parentProjects;
        }
        get LinkSubProjectModalName() {
            return this.notification.id.toString();
        }
        showRespectiveRequestTrackingModal(data) {
            const notificationId = data.requestTrackingNotificationId;
            const isAccept = data.isAccept;
            if (notificationId == this.notification.id) {
                this.ShowAcceptLinkRequestTrackingModal(isAccept);
            }
        }
        ShowAcceptLinkRequestTrackingModal(isAccept) {
            if (isAccept) {
                this.machineService.send({ type: "LINK_SUBPROJECT_WITH_PARENTPROJECT", projectId: this.notificationDetails.subProjectId });
            }
            else {
                this.notificationId = this.notification.id;
                this.machineService.send({ type: "REJECT_SUBPROJECT_LINKING" });
                this.emitRejectedNotification();
            }
        }
        //Lifecycle
        created() {
            bus.$on("showRequestTrackingModal", (data) => {
                this.showRespectiveRequestTrackingModal(data);
            });
            if (this.requestTrackingNotificationId != null) {
                if (this.requestTrackingNotificationId == this.notification.id) {
                    this.ShowAcceptLinkModal();
                }
            }
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("notificationLoaded")) {
                    this.$bvModal.hide(this.LinkSubProjectModalName);
                }
                if (this.state.matches("linkSubProjectWithParentProject")) {
                    this.$bvModal.show(this.LinkSubProjectModalName);
                }
                if (this.state.matches("notificationLoaded") && previousState.matches("linkingSubProjectWithParentProject")) {
                    this.emitRejectedNotification();
                }
                if (this.state.matches("notificationLoaded") && previousState.matches("rejectingSubProjectLinking")) {
                    this.emitRejectedNotification();
                }
            });
        }
        get notificationDetails() {
            return this.notification.notificationData;
        }
        destroyed() {
            this.machineService.stop();
            bus.$off("showRequestTrackingModal", this.showRespectiveRequestTrackingModal);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], RequestTrackingComponent.prototype, "notification", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], RequestTrackingComponent.prototype, "requestTrackingNotificationId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], RequestTrackingComponent.prototype, "isAccept", void 0);
    RequestTrackingComponent = __decorate([
        Component({
            name: "RequestTrackingComponent",
            components: {
                DeleteComponent,
                Layout,
            },
        })
    ], RequestTrackingComponent);
    return RequestTrackingComponent;
})();
export default RequestTrackingComponent;
